export default "__VITE_ASSET__27e46628__"